import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Grid from "@material-ui/core/Grid";
import { useFiltersStyles } from "./styles";
import { useHistory, useLocation } from "react-router-dom";
import { Clear, Search } from "@material-ui/icons";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { useSearchParams } from "../../../../hooks/useSearchParams";
import { useEffect, useRef, useState } from "react";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { format, parse, isValid } from "date-fns";

type Props = {
    open: boolean;
}

const initialParams = {
    status: "",
    created_at: "",
    updated_at: "",
};

export default function TotemFilters({ open }: Props) {
    const history = useHistory();
    const { pathname } = useLocation();
    const searchParams = useSearchParams();
    const [params, setParams] = useState(initialParams);
    const { classes } = useFiltersStyles();
    const formRef = useRef<HTMLFormElement>(null);
    const statusOptions = [
        { label: 'Ativo', value: 'true' },
        { label: 'Inativo', value: 'false' }
    ];

    function handleChange(event: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown; }>) {
        const { name, value } = event.target;

        setParams((prev) => ({
            ...prev,
            [name]: value,
        }));
    }

    function parseDateStr(str: string): Date | null {
        if (!str || str.trim() === "") return null;
        const parsed = parse(str, "dd/MM/yyyy", new Date());
        return isValid(parsed) ? parsed : null;
    }

    function formatDateForParams(date: Date | null): string {
        return date ? format(date, "dd/MM/yyyy") : "";
    }

    function handleClear() {
        Object.keys(initialParams).forEach((key) => {
            searchParams.delete(key);
        });
        searchParams.delete("orgao_slug");

        history.replace({
            pathname,
            search: searchParams.toString(),
        });
    }

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        const newParams = { ...params };

        newParams.created_at = (newParams.created_at as string)?.split("/").reverse().join("-") || "";
        newParams.updated_at = (newParams.updated_at as string)?.split("/").reverse().join("-") || "";

        Object.keys(newParams).forEach(key => {
            if (newParams[key] === "") {
                delete newParams[key];
            }
        });

        const newSearchParams = new URLSearchParams(newParams);

        ["page", "order", "order_by"].forEach((param) => {
            if (newSearchParams.has(param)) {
                newSearchParams.delete(param);
            }
        });

        history.replace({
            pathname,
            search: newSearchParams.toString(),
        });
    }

    useEffect(() => {
        const newParams: any = { ...initialParams };

        Array.from(searchParams.entries()).forEach(([key, value]) => {
            if (key.endsWith("_at")) {
                newParams[key] = value.split("-").reverse().join("/");
            } else {
                newParams[key] = value;
            }
        });

        setParams(newParams);
    }, [searchParams]);

    return (
        <Accordion elevation={0} expanded={open} className={classes.accordion}>
            <AccordionSummary className={classes.summary}></AccordionSummary>
            <AccordionDetails>
                <Grid
                    ref={formRef}
                    container
                    spacing={2}
                    alignItems="center"
                    component="form"
                    onSubmit={handleSubmit}
                >
                    <Grid item xs={4}>
                        <FormControl
                            fullWidth
                            size="small"
                            variant="outlined"
                        >
                            <InputLabel>
                                Status
                            </InputLabel>
                            <Select
                                name="status"
                                label="Status"
                                value={params.status}
                                onChange={handleChange}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left",
                                    },
                                    getContentAnchorEl: null,
                                }}
                            >
                                {statusOptions.map((type) => (
                                    <MenuItem key={type.value} value={type.value}>
                                        {type.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={4}>
                        <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                fullWidth
                                autoOk
                                variant="inline"
                                inputVariant="outlined"
                                size="small"
                                margin="dense"
                                label="Data de adição"
                                format="dd/MM/yyyy"
                                value={parseDateStr(params.created_at)}
                                invalidDateMessage="Data inválida"
                                onChange={(date) => {
                                    setParams((prev) => ({
                                        ...prev,
                                        created_at: formatDateForParams(date),
                                    }));
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={4}>
                        <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                fullWidth
                                autoOk
                                variant="inline"
                                inputVariant="outlined"
                                size="small"
                                margin="dense"
                                label="Data de atualização"
                                format="dd/MM/yyyy"
                                value={parseDateStr(params.updated_at)}
                                invalidDateMessage="Data inválida"
                                onChange={(date) => {
                                    setParams((prev) => ({
                                        ...prev,
                                        updated_at: formatDateForParams(date),
                                    }));
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid container item xs={12} alignItems="center" spacing={2} style={{ marginTop: 8 }}>
                        <Grid item xs={2}>
                            <Button
                                fullWidth
                                type="submit"
                                variant="outlined"
                                color="primary"
                                size="medium"
                                style={{ borderRadius: 5, textTransform: 'uppercase' }}
                                startIcon={<Search />}
                            >
                                Filtrar
                            </Button>
                        </Grid>
                        <Grid item xs={2}>
                            <Button
                                fullWidth
                                variant="outlined"
                                color="primary"
                                size="medium"
                                style={{ border: 'none', borderRadius: 5, textTransform: 'uppercase' }}
                                startIcon={<Clear />}
                                onClick={handleClear}
                            >
                                Limpar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}
